<script setup lang="ts">
import type { SendKaKaoRequest } from '~/types/common/kakao-template-info'
import { sharePopup } from '~/composables/use-marketing-popup'

defineProps<{
  html: string | undefined
  sendKakaoRequest: SendKaKaoRequest
}>()

const route = useRoute()
const targetId = ref(null)
const isAllImagesLoaded = ref(false)
const htmlArea = ref(null)
onMounted(async () => {
  await nextTick()
  // html 내 영역의 id가 target 파라미터로 들어온 경우, 해당 영역으로 앵커링
  // 1. 이미지 로드 완료 후
  // 2. target 파라미터를 id로 가진 el이 있으면 해당 el로 스크롤
  targetId.value = route.query.target
  if (targetId.value && htmlArea.value) {
    await waitForAllImagesToLoad()
    isAllImagesLoaded.value = true
  }
})

function waitForAllImagesToLoad() {
  const imgElements = htmlArea.value.querySelectorAll('img')
  const promiss = Array.from(imgElements).map((img) => {
    return new Promise((resolve) => {
      if (img.complete) {
        resolve()
      }
      else {
        img.addEventListener('load', resolve)
        img.addEventListener('error', resolve)
      }
    })
  })

  return Promise.all(promiss)
}

watch(isAllImagesLoaded, (loaded) => {
  if (loaded) {
    htmlAnchoring()
  }
})

function htmlAnchoring() {
  const el = htmlArea.value.querySelector(`#${targetId.value}`)
  if (el) {
    const headerOffset = document.querySelector('.sticky').offsetHeight
    el.scrollIntoView({ behavior: 'instant' })
    window.scrollBy(0, -headerOffset) // header가 해당 영역을 덮어 header 높이만큼 스크롤 추가
  }
}
</script>

<template>
  <div
    ref="htmlArea"
    class="relative"
  >
    <div
      v-dompurify-html="html"
    />
    <button
      class="absolute right-4 top-4 w-10 h-10 pl-[7px] bg-white/60 rounded-full"
      @click="sharePopup(sendKakaoRequest)"
    >
      <i-normal-share2
        class="pointer w-6 h-6"
      />
      <span class="hidden">공유하기</span>
    </button>
  </div>
</template>

<style scoped>

</style>
